export type RouteLocationSnapshot = {
  pathname: string;
  search: string;
  hash: string;
  state: unknown;
  key: string;
};

export type EditorNavigationState = {
  isNewPost: boolean;
  backgroundLocation?: RouteLocationSnapshot;
};

export function editorNavigationState(
  location: RouteLocationSnapshot,
  isNewPost: boolean,
): EditorNavigationState {
  return {
    isNewPost,
    ...(["/created", "/generate", "/studio"].includes(location.pathname)
      ? { backgroundLocation: location }
      : {}),
  };
}

export function draftsBackgroundLocation(
  pathname: string,
  state: unknown,
): RouteLocationSnapshot | undefined {
  if (pathname !== "/create-post" || !state || typeof state !== "object") {
    return undefined;
  }

  const backgroundLocation = (state as EditorNavigationState)
    .backgroundLocation;
  return backgroundLocation &&
    ["/created", "/generate", "/studio"].includes(backgroundLocation.pathname)
    ? backgroundLocation
    : undefined;
}
